// @needs-native-review — best-effort translation
import type { Translations } from '../types';

export const pl: Translations = {
  'meta.gameTitle': 'Luminary',

  'howto.title': 'Jak grać',
  'howto.pieces.heading': 'Elementy',
  'howto.pieces.source': 'Źródło',
  'howto.pieces.mirror': 'Lustro',
  'howto.pieces.switch': 'Przełącznik',
  'howto.pieces.exit': 'Wyjście',
  'howto.pieces.wall': 'Ściana',
  'howto.controls.heading': 'Sterowanie',
  'howto.controls.clickSlot.line1': 'Kliknij pole',
  'howto.controls.clickSlot.line2': 'połóż lustro',
  'howto.controls.dragMirror.line1': 'Przeciągnij lustro',
  'howto.controls.dragMirror.line2': 'obróć',
  'howto.controls.rightClick.line1': 'Prawy przycisk',
  'howto.controls.rightClick.line2': 'usuń lustro',
  'howto.controls.hint': 'Kółko myszy: precyzyjny obrót o 1°.   Stuknij w lustro: obrót o 15°.',
  'howto.objective.line1': 'Zapal każdy przełącznik — zamek wyjścia odskakuje.',
  'howto.objective.line2': 'Następnie kliknij wyjście. Rozwiąż jak najmniejszą liczbą luster.',

  'howtoColor.title': 'Kolor i pryzmaty',
  'howtoColor.pieces.heading': 'Nowe elementy',
  'howtoColor.pieces.prism': 'Pryzmat',
  'howtoColor.pieces.redSwitch': 'Czerwony przełącznik',
  'howtoColor.pieces.yellowSwitch': 'Żółty przełącznik',
  'howtoColor.pieces.whiteSwitch': 'Biały przełącznik',
  'howtoColor.how.heading': 'Jak działają',
  'howtoColor.how.line1':
    'Biała wiązka niesie jednocześnie światło czerwone, zielone i niebieskie.',
  'howtoColor.how.line2':
    'Pryzmat rozdziela białe światło na trzy kolorowe wiązki wzdłuż swoich trzech boków.',
  'howtoColor.how.line3': 'Kliknij umieszczony pryzmat, aby obrócić jego ścianę wejściową.',
  'howtoColor.switches.line1':
    'Przełączniki pokazują kolorowe kropki — to kolor, którego potrzebują.',
  'howtoColor.switches.line2':
    'Żółty przełącznik (kropki czerwona + zielona) potrzebuje obu kolorów naraz.',
  'howtoColor.switches.line3':
    'Biały przełącznik (wszystkie trzy) potrzebuje czerwonego, zielonego I niebieskiego naraz.',

  'options.hints.label': 'Pokaż kąty podpowiedzi w łamigłówkach',
  'options.hints.help': 'Wyświetla kąt między wiązką padającą a odbitą przy każdym odbiciu.',

  'level.01-intro.title': 'Witaj, światło',
  'level.02-two-mirrors.title': 'Dwa zakręty',
  'level.03-corner.title': 'Ściana na drodze',
  'level.04-two-targets.title': 'Dwa cele',
  'level.05-tight.title': 'Ciasno',
  'level.06-hello-color.title': 'Witaj, kolorze',
  'level.07-pick-a-side.title': 'Wybierz stronę',
  'level.08-yellow.title': 'Żółty',
  'level.09-magenta.title': 'Magenta',
  'level.10-spectrum.title': 'Spektrum',

  // PuzzleScene
  'puzzle.itemCounter': '{used}/{optimal}',
  'puzzle.hint.angleType.right': 'prosty',
  'puzzle.hint.angleType.acute': 'ostry',
  'puzzle.hint.angleType.obtuse': 'rozwarty',
  'puzzle.hint.label': '{angle}°\n{type}',
};
